import { WeChatPeopleMap } from "../manager/WeChatConst";

let peopleMap:WeChatPeopleMap = null;


export default function getPeopleMap (){
    if(!peopleMap){
        peopleMap = {
            "自己":{name:"自己",headUrl:"weChatSprite/001"},
            "管家":{name:"管家",headUrl:"weChatSprite/newHead/波斯使团"},
            "差事":{name:"差事",headUrl:"weChatSprite/newHead/差事"},
            "城中商人":{name:"城中商人",headUrl:"weChatSprite/newHead/城中商人"},
            "国舅":{name:"国舅",headUrl:"weChatSprite/newHead/国舅"},
            "皇妹":{name:"皇妹",headUrl:"weChatSprite/newHead/皇妹"},
            "江南好友":{name:"江南好友",headUrl:"weChatSprite/newHead/江南好友"},
            "老师":{name:"老师",headUrl:"weChatSprite/newHead/老师"},
            "邻居":{name:"邻居",headUrl:"weChatSprite/newHead/邻居"},
            "母妃":{name:"母妃",headUrl:"weChatSprite/newHead/母妃"},
            "乞丐":{name:"乞丐",headUrl:"weChatSprite/newHead/乞丐"},
            "神秘人":{name:"神秘人",headUrl:"weChatSprite/newHead/神秘人"},
            "私盐贩子":{name:"私盐贩子",headUrl:"weChatSprite/newHead/私盐贩子"},
            "幽州巡抚":{name:"幽州巡抚",headUrl:"weChatSprite/newHead/幽州巡抚"},
            "老妇人的孙女":{name:"老妇人的孙女",headUrl:"weChatSprite/newHead/接待官"},
            "当铺掌柜":{name:"当铺掌柜",headUrl:"weChatSprite/newHead/掌柜"},
            "百乐门掌柜":{name:"百乐门掌柜",headUrl:"weChatSprite/newHead/百乐门掌柜"},
            "包工头":{name:"包工头",headUrl:"weChatSprite/newHead/包工头"},
            "原石老板":{name:"原石老板",headUrl:"weChatSprite/newHead/平民"},
            "招募官":{name:"招募官",headUrl:"weChatSprite/newHead/招募官"},
            "曹仁":{name:"曹仁",headUrl:"weChatSprite/newHead/曹仁"},
            "马超":{name:"马超",headUrl:"weChatSprite/newHead/马超"},
            "黄忠":{name:"黄忠",headUrl:"weChatSprite/newHead/黄忠"},
            "马岱":{name:"马岱",headUrl:"weChatSprite/newHead/马岱"},
            "魏延":{name:"魏延",headUrl:"weChatSprite/newHead/魏延"},
            "夏侯惇":{name:"夏侯惇",headUrl:"weChatSprite/newHead/夏侯惇"},
            "徐晃":{name:"徐晃",headUrl:"weChatSprite/newHead/徐晃"},
            "许褚":{name:"许褚",headUrl:"weChatSprite/newHead/许褚"},
            "颜良":{name:"颜良",headUrl:"weChatSprite/newHead/颜良"},
            "赵云":{name:"赵云",headUrl:"weChatSprite/newHead/赵云"},
            "押运官":{name:"押运官",headUrl:"weChatSprite/newHead/押运官2"},
            "周瑜":{name:"周瑜",headUrl:"weChatSprite/newHead/周瑜"},
            "竹清清":{name:"竹清清",headUrl:"weChatSprite/newHead/竹清清"},
            "武林盟主":{name:"武林盟主",headUrl:"weChatSprite/newHead/武林盟主"},
            "公公":{name:"公公",headUrl:"weChatSprite/newHead/spr_gong_gong"},     
            "华贵妃":{name:"华贵妃",headUrl:"weChatSprite/newHead/spr_gui_fei"},          
            "东夷女子":{name:"东夷女子",headUrl:"weChatSprite/newHead/美艳女子"},          
        }
    }
    return peopleMap;
}

export function getOnePeopleById(id:string){
    return getPeopleMap()[id];
}
